import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SummitFishingShuttle = () => {
  console.log('🎯 SummitFishingShuttle component loading');
  
  const product = findProductById("summit-fishing-shuttle");
  
  if (!product) {
    console.error('Product not found:', "summit-fishing-shuttle");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="summit-fishing-shuttle"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SummitFishingShuttle; 